import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/common/Layout';
import DashBoardPage from './components/DashBoardPage';
import ADHOC from './images/ADHOC.svg';
import Standard from './images/Standard.svg';
import Custom from './images/Custom.svg';
import {
  // getAllStats,
  // getAllSubCategories,
  // getAllPricebrackets,
  // getAllCategories,
  getdoa,
  // getAllProjects,
  // getAllBUs,
  // getLocations,
  getPlants,
  getdashboardCount,
  getfunctions,
  getcategory,
  getactivity,
  getIONum,
  getCOSTNum,
  get_bcj
} from './redux/slice';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'antd';
import styles from './index.module.less';
// import { history } from 'app/history';
// import { message } from 'antd';

const envelopeTypes = [
  {
    title: 'Initiate ad-hoc envelope',
    subText:
      'Best suited for documents that do not have a defined division of authority process',
    btnText: 'Initiate ad-hoc envelope',
    image: ADHOC,
    key: 1
  },
  {
    title: 'Initiate standard envelope',
    subText:
      'Choose this for confidential documents or agreements with significant material impact',
    btnText: 'Initiate standard DoA envelope',
    image: Standard,
    key: 2
  },
  {
    title: 'Initiate custom DoA envelope',
    subText:
      'Select this to send documents without a standard format along a preconfigured flow',
    btnText: 'Initiate custom DoA envelope',
    image: Custom,
    key: 3
  }
];

// localStorage.removeItem('budgetType');
// localStorage.removeItem('budget_type');
// localStorage.removeItem('category');
// localStorage.removeItem('category_id');
// localStorage.removeItem('function');
// localStorage.removeItem('function_id');
// localStorage.removeItem('location');
// localStorage.removeItem('location_id');
// localStorage.removeItem('max_value');
// localStorage.removeItem('min_value');
// localStorage.removeItem('purchaseType');
// localStorage.removeItem('purchase_type');
// localStorage.removeItem('sub_category');
// localStorage.removeItem('sub_category_id');
// localStorage.removeItem('title');
// localStorage.removeItem('value');

const DashBoard = () => {
  const [form] = Form.useForm();
  // allStats, pricebrackets, categories, subcategories, projects, bu
  const {
    // get_locations,
    get_plants,
    dashboard_count,
    get_functions,
    get_category,
    get_subcategorylist,
    get_activity,
    get_ioNum,
    get_costNum,
    get_businesscasejustification
  } = useSelector((state) => state.dashboard);

  const dispatch = useDispatch();
  // useEffect(() => {
  //   handleGetStats();
  // }, []);
  useEffect(() => {
    localStorage.removeItem('emailmessage');
  }, []);

  // console.log('get_costNum', get_costNum);
  // console.log('get_businesscasejustification', get_businesscasejustification);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isStandardModalVisible, setIsStandardModalVisible] = useState(false);
  const [isCustomModalVisible, setIsCustomModalVisible] = useState(false);
  const [isStandardTemplateModalVisible, setIsStandardTemplateModalVisible] =
    useState(false);
  const [standardValues, setStandardValues] = useState([]);
  const [companyid, setCompanyId] = useState();
  const [search, setSearch] = useState('');
  const [plant, setPlant] = useState('');
  const [ionum, setIonum] = useState('');
  // const [costnum, setCostnum] = useState('');
  const [costCenters, setCostCenters] = useState([]);
  const [departmentt, setDepartmentt] = useState('');
  const [iosearch, setIOSearch] = useState('');
  const [costsearch, setCOSTSearch] = useState('');
  const [activitysearch, setactivitySearch] = useState('');
  const [departmentSearch, setDepartmentSearch] = useState('');
  // const [selectedProject, setSelectedProject] = useState([]);
  // const [searchproject, setSearchproject] = useState('');
  // const [searchCategory, setSearchCategory] = useState('');
  // const [searchSubCategory, setSearchSubCategory] = useState('');
  // const [selectedBU, setSelectedBU] = useState([]);
  // const [searchbu, setSearchbu] = useState('');
  // const [categoryId, setCategoryId] = useState('');
  // const [showProject, setShowProject] = useState(false);
  // const [category, setCategory] = useState(categories);
  const [type, setType] = useState('');
  const [payloadDataForAllStandard, setPayloadDataForAllStandard] = useState(
    {}
  );
  // const [locations, setLocations] = useState([]);

  const onFinish = (values) => {
    console.log('values', values);

    // localStorage.setItem('envelope_name', values.envelope_name);
    // localStorage.setItem('description', values.description);

    // localStorage.setItem('location', values.location);
    // localStorage.setItem('function', values.function);
    localStorage.setItem('category_id', values.category_id);
    localStorage.setItem('sub_category_id', values.sub_category_id);
    // localStorage.setItem('budgetType', values.budgetType);
    // localStorage.setItem('purchaseType', values.purchaseType);
    // localStorage.setItem('min_value', values.min_value);
    // localStorage.setItem('max_value', values.max_value);
    localStorage.setItem('activity', values.activity);
    localStorage.setItem('io_no_id', values.io_no_id);
    localStorage.setItem('io_amount', values.io_amount);
    localStorage.setItem('io_balance_amount', values.io_balance_amount);
    localStorage.setItem('cost_centr_id', values.cost_centr_id);
    localStorage.setItem('cost_center_amount', values.cost_center_amount);
    localStorage.setItem(
      'cost_center_balance_amount',
      values.cost_center_balance_amount
    );
    // localStorage.setItem('value', values.value);
    localStorage.setItem('title', values.title);

    localStorage.setItem('plant_id', values.plant_id);
    localStorage.setItem('department_id', values.department_id);
    // localStorage.setItem('budget_line', values.budget_line);
    // localStorage.setItem('budget_amount', values.budget_amount);
    localStorage.setItem('nfa_amount', values.nfa_amount);
    localStorage.setItem('balance_amount', values.balance_amount);

    navigate('/initiate-envelope-1');
    form.resetFields();
  };

  // const handleGetStats = () => {
  // dispatch(getAllStats());
  // dispatch(getAllPricebrackets());
  // dispatch(getLocations());
  // };

  // useEffect(() => {
  //   const payload = { search: searchCategory };
  //   dispatch(getAllCategories(payload));
  // }, [searchCategory]);

  // useEffect(() => {
  //   handleGetAllProjects();
  //   handlegetLocations();
  //   dashboardCount();
  // }, [searchproject]);

  // const handleGetAllProjects = () => {
  //   dispatch(getAllProjects(searchproject));
  // };
  useEffect(() => {
    console.log('search', search);
    const payload = { search: search };
    dispatch(getPlants(payload));
  }, [search]);
  // console.log('setSearch', setSearch);

  useEffect(() => {
    console.log('search', iosearch);
    const payload = { search: iosearch };
    dispatch(getIONum(payload));
  }, [iosearch]);
  // console.log('setIOSearch', setIOSearch);

  useEffect(() => {
    console.log('search', costsearch);
    const payload = { search: costsearch };
    dispatch(getCOSTNum(payload));
  }, [costsearch]);
  // console.log('setCOSTSearch', setCOSTSearch);

  useEffect(() => {
    console.log('search', activitysearch);
    const payload = { search: activitysearch };
    dispatch(getactivity(payload));
  }, [activitysearch]);
  // console.log('setactivitySearch', setactivitySearch);

  // departmentSearch
  useEffect(() => {
    console.log('search', departmentSearch);
    const payload = { search: departmentSearch };
    dispatch(getfunctions(payload));
  }, [departmentSearch]);

  useEffect(() => {
    // handlegetLocations();
    handlegetPlants();
    dashboardCount();
    handlegetfunctions();
    handlegetcategory();
    handlegetactivity();
    handlegetIONum();
    handlegetCOSTNum();
    handlegetBCJ();
  }, []);
  const dashboardCount = () => {
    dispatch(getdashboardCount());
    // dispatch(getLocations());
    dispatch(getPlants());
    dispatch(getfunctions());
    dispatch(getcategory());
    dispatch(getactivity());
    dispatch(getIONum());
    dispatch(getCOSTNum());
  };

  useEffect(() => {
    const handleOpenStandardModal = () => {
      // Close current modal (Custom/Template)
      setIsStandardTemplateModalVisible(false);
      setIsCustomModalVisible(false);

      // Open Standard modal again
      setIsStandardModalVisible(true);
    };

    // Listen for "openStandardModal" event
    window.addEventListener('openStandardModal', handleOpenStandardModal);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('openStandardModal', handleOpenStandardModal);
    };
  }, []);

  // const handlegetLocations = () => {
  //   dispatch(getLocations());
  // };

  const handlegetPlants = () => {
    dispatch(getPlants());
  };

  const handlegetIONum = () => {
    dispatch(getIONum());
  };

  const handlegetCOSTNum = () => {
    dispatch(getCOSTNum());
  };
  const handlegetBCJ = () => {
    dispatch(get_bcj());
  };

  const handlegetfunctions = () => {
    dispatch(getfunctions());
  };

  const handlegetcategory = () => {
    dispatch(getcategory());
  };

  const handlegetactivity = () => {
    dispatch(getactivity());
  };

  // useEffect(() => {
  //   handleGetAllBU();
  // }, [searchbu]);

  // const handleGetAllBU = () => {
  //   dispatch(getAllBUs(searchbu));
  // };

  // console.log('getLocations', get_locations);
  // console.log('dashboard_count', dashboard_count);

  const showModal = () => {
    setIsModalVisible(true);
    form.resetFields();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const showStandardModal = (value) => {
    localStorage.removeItem('apiCallValues');
    setIsStandardModalVisible(true);
    // console.log('value', value);
    setType(value === 1 ? 'standard' : 'custom');
    form.resetFields();
  };

  const handleStandardCancel = () => {
    setIsStandardTemplateModalVisible(false);
    setIsStandardModalVisible(false);
    form.resetFields();
  };

  const handleStandardtemplateCancel = () => {
    setIsStandardTemplateModalVisible(false);
    form.resetFields();
  };

  const showCustomdModal = () => {
    localStorage.removeItem('apiCallValues');
    setIsCustomModalVisible(true);
    form.resetFields();
  };

  const handleCustomCancel = () => {
    setIsCustomModalVisible(false);
    form.resetFields();
  };

  // const handleCategory = (e) => {
  //   const payload = {
  //     category_id: e,
  //     sub_search: searchSubCategory
  //   };
  //   var filter = categories.filter((categories) => categories.id === e);

  //   filter[0].is_active_project ? setShowProject(true) : setShowProject(false);
  //   dispatch(getAllSubCategories(payload));
  // };

  // useEffect(() => {
  //   const payload = {
  //     category_id: categoryId,
  //     sub_search: searchSubCategory
  //   };
  //   dispatch(getAllSubCategories(payload));
  // }, [searchSubCategory]);

  // const handleSubCategory = (e) => {
  //   var filter = subcategories.filter(
  //     (subcategories) => subcategories.id === e
  //   );
  //   filter[0].is_active_project ? setShowProject(true) : setShowProject(false);
  // };

  // const onSelectProject = (data) => {
  //   setSelectedProject([...selectedProject, { project: data.project }]);
  // };

  // const onSearch = (value) => {
  //   setSearchproject(value);
  // };

  // const onSearchCategory = (value) => {
  //   setSearchCategory(value);
  // };

  // const onSearchSubCategory = (value) => {
  //   setSearchSubCategory(value);
  // };
  // const onSelectBU = (data) => {
  //   setSelectedBU([...selectedBU, { bu: data.bu }]);
  // };

  // const onSearchbu = (value) => {
  //   setSearchbu(value);
  // };

  const handleSearchstandard = (payload) => {
    setPayloadDataForAllStandard(payload);
    dispatch(getdoa(payload)).then((response) => {
      response.payload.data
        ? (setStandardValues(response.payload.data),
          setIsStandardTemplateModalVisible(true),
          setIsStandardModalVisible(false))
        : // ? history.push(
          //     '/initiate-envelope-1/' +
          //       `${response.payload.data.id}?type=${payload.type}`
          //   )
          // : message.error(response.payload.message);
          (setIsStandardTemplateModalVisible(true),
          setIsStandardModalVisible(false));
    });
  };
  // console.log('setPayloadDataForAllStandard', setPayloadDataForAllStandard);
  const [previousActionRequiredCount, setPreviousActionRequiredCount] =
    useState(
      () => Number(localStorage.getItem('previousActionRequiredCount')) || 0
    );

  const [showDot, setShowDot] = useState(false);
  console.log('showDot', showDot);

  // Check if the count has increased
  useEffect(() => {
    const currentCount = dashboard_count?.waiting_for_others || 0;

    if (currentCount > previousActionRequiredCount) {
      setShowDot(true);
      setPreviousActionRequiredCount(currentCount);
      localStorage.setItem('previousActionRequiredCount', currentCount);
    }
  }, [dashboard_count?.waiting_for_others, previousActionRequiredCount]);

  // Optionally, hide the dot after 24 hours
  useEffect(() => {
    if (showDot) {
      const timer = setTimeout(() => setShowDot(false), 24 * 60 * 60 * 1000); // Hide after 24 hours
      return () => clearTimeout(timer); // Cleanup timer on component unmount
    }
  }, [showDot]);

  const stats = [
    {
      key: 1,
      label: 'Actions required',
      value: dashboard_count?.action_required || 0,
      // link: '/actions-required',
      link: '/pending',
      showDot: showDot // Add showDot flag to the stats object
    },
    {
      key: 2,
      label: 'Waiting for others',
      value: dashboard_count?.waiting_for_others || 0,
      link: '/manage',
      showDot: showDot
    },
    {
      key: 3,
      // label: 'Need Clarification',
      label: 'My approvals',
      value: dashboard_count?.completed || 0,
      link: '/myapprovels'
    },
    {
      key: 4,
      // label: 'Completed',
      label: 'My rejections',
      value: dashboard_count?.rejected || 0,
      link: '/myrejections'
    }
  ];

  return (
    <>
      <Layout sider={false}>
        {stats.map((stat) => (
          <div key={stat.key} className={styles.key}>
            <a href={stat.link}>
              <span>
                {stat.label}: {stat.value}
              </span>
              {stat.showDot && <span className="dot" />}{' '}
            </a>
          </div>
        ))}
        <DashBoardPage
          // setSearchSubCategory={setSearchSubCategory}
          // setCategoryId={setCategoryId}
          // onSearchSubCategory={onSearchSubCategory}
          form={form}
          // onSearchCategory={onSearchCategory}
          payloadDataForAllStandard={payloadDataForAllStandard}
          stats={stats}
          envelopeTypes={envelopeTypes}
          isModalVisible={isModalVisible}
          isStandardModalVisible={isStandardModalVisible}
          isCustomModalVisible={isCustomModalVisible}
          onFinish={onFinish}
          showModal={showModal}
          showCustomdModal={showCustomdModal}
          showStandardModal={showStandardModal}
          handleCancel={handleCancel}
          handleCustomCancel={handleCustomCancel}
          handleStandardCancel={handleStandardCancel}
          // allStats={allStats}
          setIsCustomModalVisible={setIsCustomModalVisible}
          // pricebrackets={pricebrackets}
          // categories={categories}
          // handleCategory={handleCategory}
          // subcategories={subcategories}
          handleSearchstandard={handleSearchstandard}
          isStandardTemplateModalVisible={isStandardTemplateModalVisible}
          setIsStandardTemplateModalVisible={setIsStandardTemplateModalVisible}
          standardValues={standardValues}
          setStandardValues={setStandardValues}
          handleStandardtemplateCancel={handleStandardtemplateCancel}
          // onSelectProject={onSelectProject}
          // onSearch={onSearch}
          // projects={projects}
          // onSelectBU={onSelectBU}
          // onSearchbu={onSearchbu}
          // bu={bu}
          // showProject={showProject}
          // handleSubCategory={handleSubCategory}
          // setCategory={setCategory}
          // category={category}
          // locations={get_locations}
          plants={get_plants}
          dashboardcount={dashboardCount}
          type={type}
          functions={get_functions}
          category={get_category}
          activity={get_activity}
          subcategory={get_subcategorylist}
          setCompanyId={setCompanyId}
          companyid={companyid}
          setSearch={setSearch}
          setPlant={setPlant}
          plant={plant}
          setDepartmentt={setDepartmentt}
          departmentt={departmentt}
          get_IONumbers={get_ioNum}
          setIonum={setIonum}
          ionum={ionum}
          get_COSTNumber={get_costNum}
          setCostnum={setCostCenters}
          costnum={costCenters}
          setIOSearch={setIOSearch}
          setCOSTSearch={setCOSTSearch}
          setactivitySearch={setactivitySearch}
          setDepartmentSearch={setDepartmentSearch}
          get_businesscasejustification={get_businesscasejustification}
        />
      </Layout>
    </>
  );
};

export default DashBoard;
